if (!customElements.get("swiper-slider")) {
  class SwiperSlider extends HTMLElement {
    constructor() {
      super();
      this.slideContainer = this.querySelector("[data-swiper]:not([data-swiper-thumbs])");
      this.slides = this.querySelectorAll("[data-swiper-slide]");
      
      this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions());
      this.activeIndex = 0;
      this.initialized = false;
      if (this.dataset.swiperThumbs) {
        this.thumbnails = this.querySelector('[data-swiper-thumbs]');
      }
      if (this.dataset.customEvent) {
        this.attachCustomListeners(this.dataset.customEvent);
      }
      if (this.slideContainer && this.slides.length > 0) {
        
        document.addEventListener(
          "DOMContentLoaded",
          this.initializeSwiper.bind(this)
        );
        document.addEventListener(
          "shopify:section:load",
          this.initializeSwiper.bind(this)
        );
        window.addEventListener("resize", this.handleResize.bind(this));
      } else {
        console.warn("SwiperSlider - Slider or Slides Not Found");
      }
    }
    attachCustomListeners(customEvent) {
      switch (customEvent) {
        case "swiper_event":
          document.addEventListener("swiper_event", this.updateSlides.bind(this));
          break;
      }
    }
    updateSlides(event) {
    }
    applyDefaultOptions(options) {
      if (options.loop === undefined) {
        options.loop = true;
      }
      options.speed = 400;
      return options;
    }

    getSliderOptions() {
      try {
        return JSON.parse(this.dataset.swiperOptions);
      } catch (err) {
        console.log(err);
        return {};
      }
    }

    initializeSwiper() {
      if (window.Swiper && !this.initialized) {
        this.initialized = true;
        if(this.thumbnails) {
          this.setThumbnails()
        }
        this.slider = new Swiper(this.slideContainer, this.sliderOptions);
        this.initializeSliderEventListeners();
      } else if (!window.Swiper) {
        console.warn("SwiperSlider - Swiper.js not found");
      }
    }

    handleResize(e) {
      if (this.slider) {
        setTimeout(() => {
          this.slider.updateSize();
        }, 300);
      }
    }

    setThumbnails() {
      const thumbsSlideContainer = this.thumbnails;
      const thumbOptions = JSON.parse(this.thumbnails.dataset.swiperOptions);
      const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
      this.sliderOptions.thumbs = {swiper: thumbnailsSlider};
    }

    initializeSliderEventListeners() {
      if (!this.slider || this.dataset.swiperVideo !== "true") return;

      this.slider.on("init", () => {
        this.pauseAllSlideVideos();
        this.playVisibleSlideVideo();
      });

      this.slider.on("slideChangeTransitionStart", () => {
        this.pauseAllSlideVideos();
      });

      this.slider.on("slideChangeTransitionEnd", () => {
        this.playVisibleSlideVideo();
      });

      // Ensure first visible slide can autoplay even if init has already fired.
      this.pauseAllSlideVideos();
      this.playVisibleSlideVideo();
    }

    getSlideVideoController(slide) {
      if (!slide) return null;

      const customVideo = slide.querySelector("custom-video");
      if (customVideo && typeof customVideo.play === "function" && typeof customVideo.pause === "function") {
        return customVideo;
      }

      const video = slide.querySelector("video");
      if (!video) return null;

      return {
        play: () => {
          const playPromise = video.play?.();
          if (playPromise && typeof playPromise.catch === "function") {
            playPromise.catch(() => {});
          }
        },
        pause: () => {
          video.pause?.();
        }
      };
    }

    pauseAllSlideVideos() {
      if (!this.slideContainer) return;

      const slides = Array.from(this.slideContainer.querySelectorAll(".swiper-slide"));
      slides.forEach((slide) => {
        const videoController = this.getSlideVideoController(slide);
        videoController?.pause?.();
      });
    }

    playVisibleSlideVideo() {
      if (!this.slideContainer || !this.slider) return;

      const activeSlide =
        this.slideContainer.querySelector(".swiper-slide-active") ||
        this.slider.slides?.[this.slider.activeIndex];
      const customVideo = activeSlide?.querySelector("custom-video");
      if (customVideo && String(customVideo.dataset.autoplay) === "false") return;

      const videoController = this.getSlideVideoController(activeSlide);
      videoController?.play?.();
    }
  }
  customElements.define("swiper-slider", SwiperSlider);
  
}
